import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/sections/Navigation";
import { Hero } from "./components/sections/Hero";
import { About } from "./components/sections/About";
import { Products } from "./components/sections/Products";
import { Industries } from "./components/sections/Industries";
import { Infrastructure } from "./components/sections/Infrastructure";
import { Quality } from "./components/sections/Quality";
import { Sustainability } from "./components/sections/Sustainability";
import { Contact } from "./components/sections/Contact";
import CareersPage from "./pages/Careers";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="relative bg-bone text-ink min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <Products />
      <Industries />
      <Infrastructure />
      <Quality />
      <Sustainability />
      <Contact />
    </main>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/careers" element={<CareersPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
